import { Skeleton } from 'antd';
import { ReactElement, useMemo } from 'react';

import { Checkbox, CheckboxGroup, ConditionView, Typography } from '@/shared/ui';

import { REMOVED_ALL_CATEGORIES_VALUE } from '../../model';

interface InternalServicesCategoriesProps {
  isCategoriesLoading: boolean;
  onFilter: (filterType: 'query' | 'category', value: string | string[]) => void;
  selectedCategories: string[];
  defaultCategories: string[];
}

const renderCategoriesSkeleton = (): ReactElement[] =>
  Array.from({ length: 5 }, (_, idx) => idx).map((item) => (
    <div key={item} style={{ display: 'flex', gap: 8 }}>
      <Skeleton.Avatar style={{ width: 16, height: 16 }} active size="small" shape="square" />
      <Skeleton.Input style={{ height: 16 }} size="small" block active />
    </div>
  ));

export const InternalServicesCategories: React.FC<InternalServicesCategoriesProps> = ({
  isCategoriesLoading,
  onFilter,
  selectedCategories,
  defaultCategories,
}) => {
  const indeterminate = useMemo<boolean>(
    () =>
      selectedCategories.length > 0 &&
      selectedCategories.length < defaultCategories.length &&
      selectedCategories.some((category) => category !== REMOVED_ALL_CATEGORIES_VALUE),
    [defaultCategories, selectedCategories],
  );
  const isAllCategoriesSelected = selectedCategories?.length === defaultCategories.length;

  return (
    <div className="internal-services-page__search-block__checkbox-container">
      <Typography variant="H3">Категорії</Typography>

      <ConditionView if={!isCategoriesLoading} else={renderCategoriesSkeleton()}>
        <Checkbox
          indeterminate={indeterminate}
          onChange={(): void => {
            onFilter('category', 'all');
          }}
          checked={isAllCategoriesSelected}
          label="Всі"
        />

        <CheckboxGroup
          options={defaultCategories.map((category) => ({ label: category, value: category }))}
          value={selectedCategories}
          onChange={(val): void => {
            onFilter('category', val);
          }}
          className="internal-services-page__search-block__checkbox-container__checkbox-group"
        />
      </ConditionView>
    </div>
  );
};
